/* Project Import will be here */
import { applyFilterApi } from "../services/products";
import {
  getErrorObject,
  normalizeByGroup,
  mergeMultipleSchemeProducts
} from "../utilities/utils";
/* Project Import will be here */

export const types = {
  PRODUCTS_REQUEST: "HOT_DEALS/PRODUCTS_REQUEST",
  PRODUCTS_SUCCESS: "HOT_DEALS/PRODUCTS_SUCCESS",
  PRODUCTS_FAILURE: "HOT_DEALS/PRODUCTS_FAILURE",
  HOT_DEALS_UPDATE_IS_FAV: "HOT_DEALS/HOT_DEALS_UPDATE_IS_FAV"
};

const initialState = {
  groupIds: [],
  group: {},
  isLoading: false,
  ids: [],
  data: {},
  count: null,
  error: null
};

export const hotDeals = (state = initialState, action) => {
  switch (action.type) {
    case types.PRODUCTS_REQUEST: {
      return {
        ...initialState,
        isLoading: true
      };
    }
    case types.PRODUCTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isLoading: false
      };
    case types.PRODUCTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    case types.HOT_DEALS_UPDATE_IS_FAV:
      let { ProductId, IsFavourite } = action.payload;
      if (ProductId in state.data) {
        return {
          ...state,
          data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
          error: null,
          isLoading: false
        }
      }
      else {
        return state;
      }
    default:
      return state;
  }
};

export const getSchemeProducts = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.PRODUCTS_REQUEST });
    try {
      /* Get the scheme product for hot deals */
      const requestObj = {
        NeedScheme: true,
        Page: 1,
        Sorting: getState().appSettings.defaultProductSorting
      };
      const response = await applyFilterApi(requestObj);

      /* Merge the multi scheme products */
      const schemeProductList = mergeMultipleSchemeProducts(response.data.Data);

      let payload = normalizeByGroup({
        data: schemeProductList,
        key: "ProductId",
        groupKey: "GroupId"
      });
      payload.count = schemeProductList.length;

      dispatch({ type: types.PRODUCTS_SUCCESS, payload });
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.PRODUCTS_FAILURE,
        payload: { error: message }
      });
    }
  };
};